'use client'

import { useEffect } from 'react'

export function useScrollReveal() {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll('.scroll-reveal:not(.revealed)').forEach((el) => {
        const rect = el.getBoundingClientRect()
        if (rect.top < window.innerHeight - 40) {
          el.classList.add('revealed')
        }
      })
    }

    reveal()
    window.addEventListener('scroll', reveal, { passive: true })
    return () => window.removeEventListener('scroll', reveal)
  }, [])
}
